export const handle = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4 10L24 10V8L4 8V10ZM24 15L4 15V13L24 13V15ZM24 20H4V18H24V20Z"
    fill="currentColor"
  />
);
